import { action } from 'typesafe-actions';
import * as constants from './constants';
import * as models from '../../models';

// Contacts
export const addContactSimple = (request: models.ContactSimple) =>
    action(constants.ADD_CONTACT_SIMPLE, { request }); 

export const addCompanyExaminer = (contact: models.ContactSimple) =>
    action(constants.ADD_COMPANY_EXAMINER, { contact }); 

export const addReviewer = (contact: models.ContactSimple) =>
    action(constants.ADD_REVIEWER, { contact }); 

export const createContact = (request: models.Contact) => 
    action(constants.CREATE_CONTACT, { request }); 

export const requestCompanyExaminersList = (paging: models.Paging, companyName: string) => 
    action(constants.REQUEST_COMPANY_EXAMINERS, { paging, companyName }); 

export const receiveCompanyExaminersList = (response: models.ContactSimpleResponse) => 
    action(constants.RECEIVE_COMPANY_EXAMINERS, { response }); 

export const requestContact = (contactId: number) =>
    action(constants.REQUEST_CONTACT, { contactId }); 

export const receiveContact = (contact : models.Contact) =>
    action(constants.RECEIVE_CONTACT, { contact });    

export const requestContactList = (request: models.ContactsRequest) =>
    action(constants.REQUEST_CONTACT_LIST, { request }); 

export const receiveContactList = (response: models.ContactSimpleResponse) =>
    action(constants.RECEIVE_CONTACT_LIST, { response }); 

export const requestContactAuditLogs = (request: models.ContactSpecificAuditLogSearch) =>
    action(constants.REQUEST_CONTACT_AUDITS, { request }); 
export const receiveContactAuditLogs = (response: models.ContactAuditLogResponse) =>
    action(constants.RECEIVE_CONTACT_AUDITS, { response }); 

export const requestContactsCSV = (request: models.ContactsRequest) =>
    action(constants.REQUEST_CONTACTS_CSV, { request });     

export const receiveContactsCSV = () =>
    action(constants.RECEIVE_CONTACTS_CSV);    

export const requestContactListFailure = () =>
    action(constants.REQUEST_CONTACT_LIST_FAILURE); 

export const requestContactDupes = (contactId: number) => 
    action(constants.REQUEST_CONTACT_DUPES, { contactId }); 
export const receiveContactDupes = (response: models.ConctactDupeResponse) =>
    action(constants.RECEIVE_CONTACT_DUPES, { response }); 
export const requestContactDupesFailure = () =>
    action(constants.REQUEST_CONTACT_DUPES_FAILURE);

export const requestContactMerge = (contactId: number, payload: number[]) => 
    action(constants.REQUEST_CONTACT_MERGE, { contactId, payload });
export const receiveContactMerge = (response: models.Contact) =>
    action(constants.RECEIVE_CONTACT_MERGE, { response });
export const requestContactMergeFailure = () => 
    action(constants.REQUEST_CONTACT_MERGE_FAILURE);

export const requestContactSync = (request: number) =>
    action(constants.REQUEST_CONTACT_SYNC, { request }); 
export const receiveContactSync = (response: models.Contact) =>
    action(constants.RECEIVE_CONTACT_SYNC, { response }); 

export const requestExaminersList = (request: models.ContactsRequest) =>
    action(constants.REQUEST_EXAMINERS_LIST, { request }); 

export const receiveExaminersList = (response: models.ContactSimpleResponse) =>
    action(constants.RECEIVE_EXAMINERS_LIST, { response }); 

export const requestFieldAdjustersList = (request: models.Paging) =>
    action(constants.REQUEST_FIELD_ADJSTERS_LIST, { request }); 

export const receiveFieldAdjsutersList = (response: models.ContactSimpleResponse) =>
    action(constants.RECEIVE_FIELD_ADJSTERS_LIST, { response }); 

export const requestFieldDirectorsList = (request: models.Paging) =>
    action(constants.REQUEST_FIELD_DIRECTORS_LIST, { request }); 

export const receiveFieldDirectorsList = (response: models.ContactSimpleResponse) =>
    action(constants.RECEIVE_FIELD_DIRECTORS_LIST, { response });     

export const requestReviewersList = (request: models.Paging) =>
    action(constants.REQUEST_REVIEWERS_LIST, { request }); 

export const receiveReviewersList = (response: models.ContactSimpleResponse) =>
    action(constants.RECEIVE_REVIEWERS_LIST, { response });
    
export const updateContact = (contactId: number, patch: any[], updatedContact: models.Contact) =>
    action(constants.UPDATE_CONTACT, { contactId, patch, updatedContact }); 
export const updateContactFailure = () => 
    action(constants.UPDATE_CONTACT_FAILURE); 

// dropdowns
export const requestAdjustersDD = () =>
    action(constants.REQUEST_ADJUSTERS_DD); 
export const receiveAdjustersDD = (response: models.DropdownListResponse) =>
    action(constants.RECEIVE_ADJUSTERS_DD, { response }); 

export const requestCompanyExaminersDD = (companyName: string) =>
    action(constants.REQUEST_COMPANY_EXAMINERS_DD, { companyName }); 
export const receiveCompanyExaminersDD = (response: models.DropdownListResponse) =>
    action(constants.RECEIVE_COMPANY_EXAMINERS_DD, { response }); 

export const requestExaminersDD = () =>
    action(constants.REQUEST_EXAMINERS_DD); 
export const receiveExaminersDD = (response: models.DropdownListResponse) =>
    action(constants.RECEIVE_EXAMINERS_DD, { response }); 

export const requestFieldDirectorsDD = () =>
    action(constants.REQUEST_FIELD_DIRECTORS_DD); 
export const receiveFieldDirectorsDD = (response: models.DropdownListResponse) =>
    action(constants.RECEIVE_FIELD_DIRECTORS_DD, { response }); 

export const requestReviewersDD = () =>
    action(constants.REQUEST_REVIEWERS_DD); 
export const receiveReviewersDD = (response: models.DropdownListResponse) =>
    action(constants.RECEIVE_REVIEWERS_DD, { response }); 

// Search
export const requestContactsList = (request: models.ContactsRequest) => 
    action(constants.REQUEST_CONTACTS_LIST, { request });
export const receiveContactsList = (response: models.ContactSimpleResponse) => 
    action(constants.RECEIVE_CONTACTS_LIST, { response });